import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Space, Select } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getUserDetails, doUserCreate, doUserUpdate 
} from "../../../../redux/user/userState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { DATE_FORMAT } from '../../../../variables/constants';
import RegionProvinceBarangay from "components/fields/RegionProvinceBarangay";
import { FormatDateValue } from "../../../../utils/index";
import { QRCodeCanvas } from 'qrcode.react';

const dateFormat = 'YYYY-MM-DD';

const UserForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, errors, regions, provinces, municipalities, barangays, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			
			const { user_details, type, ...restData } = recordData;
	        const initialValues = {
				...user_details,
				...type,
				...Object.fromEntries(
					Object.entries(user_details.address || {}).map(([key, value]) => [`address_${key}`, value])
				),	
				...restData,
				date_of_birth: user_details?.date_of_birth ? FormatDateValue(user_details?.date_of_birth) : null,
	        };

	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  

console.log(formData);

			formData.date_of_birth = formData.date_of_birth?.format('YYYY-MM-DD');
			formData.type_id = 3;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>

				<FormItem
			        name="type_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>

				{recordData?.id > 0 ? 
					<div className="grid grid-cols-4">
						<FormItem 
							name="username"
							label="Username"
							rules={[requiredField()]}
						>
							{mode === 'edit' ?
							<Input id="username"
								maxLength={100}	
								readOnly={true}	  
								disabled={recordData?.type_id == 3}          		
							/>
							: <label className="ps-3 dark:text-white">{recordData?.username}</label>
							}	                
						</FormItem>
						<div className="w-full mb-4 text-right">
							<QRCodeCanvas value={JSON.stringify(recordData?.QRData)} size={150}/>
						</div>
					</div>
					:
					<div>
						<FormItem
							name="type_id"
							hidden
						>
							<Input type="hidden"/>
						</FormItem>
					</div>
				}
				<div className="grid grid-cols-4">
					<FormItem 
						name="last_name"
						label="Last Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="last_name"
							maxLength={50}		            		
							/> 
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.last_name}</label>
						}           
					</FormItem>        
					<FormItem 
						name="first_name"
						label="First Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="first_name"
						maxLength={50}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.first_name}</label>
						}  
					</FormItem>
					<FormItem 
						name="middle_name"
						label="Middle Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="middle_name"
						maxLength={50}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.middle_name}</label>
						}  
					</FormItem>
					<FormItem 
						name="suffix"
						label="Extension Name"					
					>
						{mode === 'edit' ?
						<Input id="suffix"
						maxLength={20}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.suffix}</label>
						}  
					</FormItem>									            	            		            	 
					<FormItem 
						name="gender_id"
						label="Gender"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Select id="gender_id"
							allowClear={true}
							 options={recordData?.genderOptions}		           
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.gender?.name}</label>
						}  
					</FormItem>
					<FormItem 
						name="date_of_birth"
						label="Date of Birth"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<DatePicker id="date_of_birth"
						format={DATE_FORMAT}
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.date_of_birth}</label>
						}  
					</FormItem>
					<FormItem 
						extra="col-span-2"
						name="place_of_birth"
						label="Place of Birth"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="place_of_birth"
						maxLength={100}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.place_of_birth}</label>
						}  
					</FormItem>
				</div>
		
				<label className="form-section-label">ADDRESS</label>
				<div className="form-column-4">				
					<FormItem extra="col-span-2"
						name="address_address_line1"
						label="House/Lot/Bldg. No./Purok"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="address_address_line1"
						maxLength={100}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.address?.address_line1}</label>
						}  
					</FormItem>
					<FormItem extra="col-span-2"
						name="address_address_line2"
						label="Street/Sitio/Subdv."
					>
						{mode === 'edit' ?
						<Input id="address_address_line2"
						maxLength={100}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.address?.address_line2}</label>
						}  
					</FormItem>
					<div className="col-span-4">
						<RegionProvinceBarangay recordData={recordData?.user_details} 
						mode={mode}
						form={form} 
						rules={[requiredField()]}/>
					</div>
				</div>	

				{(mode === 'edit' && recordData?.id > 0) &&
				<>
					<div className="my-5">
						<label className="form-section-label">CHANGE PASSWORD</label>
					</div>				
					<div className="grid grid-cols-4">				
						<FormItem 
							name="password"
							label="New Password"
							rules={[
								() => ({
									validator(_, value) {
										if (!value) {
											return Promise.resolve();
										}
										const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;
										if (!regex.test(value)) {
											return Promise.reject(new Error("Password must be of 8 characters with at least one uppercase, one lowercase, and a number"));
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input id="password"
								type="password"
								maxLength={100}
							/>						
						</FormItem>
						<FormItem 
							name="password_confirmation"
							label="Confirm Password"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value) {
											return Promise.resolve();
										}									
										const password = getFieldValue('password');					
										if (value !== password) {
											return Promise.reject(new Error(`Confirm password doesn't match`));
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input id="password_confirmation"
								type="password"
								maxLength={100}
							/>
						</FormItem>	
					</div>
				</>
				}
	 			<CrudButtons baseRoute="/console/farmer-users" mode={mode} recordId={recordId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.user.userDetails?.data,
  	requesting: state.user.userDetails?.requesting,
  	success: state.user.userDetails?.success,
	regions: state.psgcData.regions?.items,
	provinces: state.psgcData.provinces?.items,
	municipalities: state.psgcData.municipalities?.items,
	barangays: state.psgcData.barangays?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getUserDetails(id)),
  	doCreate: (data) => dispatch(doUserCreate(data)),
  	doUpdate: (data) => dispatch(doUserUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
